import React, { useState, useContext, useEffect } from "react";
import smallTick from "../../../assets/UserProfile/green-small-tick.svg";
import smallTickClose from "../../../assets/UserProfile/red-close-small.svg";
import edit_circle_gray from "../../../assets/UserProfile/edit_circle_gray.svg";
import view_circle_gray from "../../../assets/UserProfile/view_circle_gray.svg";
import delete_ciircle_gray from "../../../assets/UserProfile/delete_ciircle_gray.svg";
import UserProfileModal from "../UserProfileModal";
import validator from "validator";
import { Formerror } from "../../../components/formerror";
import dotsimg from "../../../assets/UserProfile/userdetailsEllipse.svg";
import { useGlobalSpinnerActionsContext } from "../../../components/loader/useloader";
import configData from "../../../utils/config/config.json";
import { Context } from "../../../services/apiContext";
import { getClientIp, maskingFunction } from "../../../helperFunctions/helperFunctions";
import { useNotificationActionsContext } from "../../../components/notificationModal/useModal";
import { useNavigate } from "react-router-dom";
import InfoLogo from "../../../components/Info";
const BankDetails = ({
  nextStep,
  bankDetails,
  handleInputDataBank,
  handleValidity,
  profileData,
  dematData,
}) => {
  const contextapi = useContext(Context);
  const navigate = useNavigate();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const setNotifi = useNotificationActionsContext();
  const [bankDetailsErrors, setBankDetailsErrors] = useState({});
  const checkErrors = async (data) => {
    const errorsForm = {};
    if (data.ifsc.trim() === "") {
      errorsForm.ifsc = "IFSC is required";
    }
    if (data.bankname.trim() === "") {
      errorsForm.bankname = "Bank Name is required";
    }

    if (data.bankaccno.trim() === "") {
      errorsForm.bankaccno = "Bank Account No  is required";
    }
    if (
      data.bankaccno.trim() !== "" &&
      !validator.matches(data.bankaccno, "[0-9]{9,18}")
    ) {
      errorsForm.bankaccno = "Bank Account No  is invalid";
    }

    return errorsForm;
  };
  const [confirmationName, setconfirmationName] = useState("delete");
  useEffect(() => {
    console.log(dematData);

    if (bankDetails.bankList.length === 0) {
      getDepositorData();
    }
  }, []);
  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    handleInputDataBank(name, value);
    if (name === "ifsc") {
      ifscValidation(value);
    }
  };
  const handleOnAddAccount = async () => {
    setGlobalSpinner(true);
    const error = await checkErrors(bankDetails);
    if (Object.keys(error).length > 0) {
      await setBankDetailsErrors(error);
      setGlobalSpinner(false);
    } else {
      addBankDetails();
    }
  };

  const addBankDetailsFirst = async (bankList) => {
    var url = "/userp/addmandate";
    var useData = contextapi.getSession("userData").user_key;
    var mandates = [];
    var panToken = contextapi.getSession("userData").pan;
    bankList.forEach((element) => {
      let newData = {};
      newData.ifsc = element.ifsc;
      newData.bank_name = element.bankname;
      newData.accno = Number(element.bankaccno);
      mandates.push(newData);
    });

    var postData = {
      user_key: useData,
      pan: profileData.pan === "" ? panToken : profileData.pan,

      user_ip: await getClientIp(),

      mandates: mandates,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setGlobalSpinner(false);

          setBankDetailsErrors({});
        } else {
          setNotifi({ val: true, msg: "Something went wrong" });
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const addBankDetails = async () => {
    var url = "/userp/addmandate";
    var useData = contextapi.getSession("userData").user_key;
    var mandates = [];

    // dematData.dematList.forEach((element) => {
    let newData = {};
    newData.ifsc = bankDetails.ifsc;
    newData.bank_name = bankDetails.bankname;
    newData.accno = Number(bankDetails.bankaccno);
    mandates.push(newData);
    // });

    var postData = {
      user_key: useData,
      pan: profileData.pan,

      user_ip:await getClientIp(),

      mandates: mandates,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setGlobalSpinner(false);
          setNotifi({ val: true, msg: "Bank Details Added Successfully" });
          var olddata = bankDetails.bankList;

          let newData = {};
          newData.ifsc = bankDetails.ifsc;
          newData.bankname = bankDetails.bankname;
          newData.bankaccno = bankDetails.bankaccno;
          newData.status = "non-verified";
          newData.isMasked = true;
          console.log(newData);
          olddata.unshift(newData);
          console.log(olddata);
          handleInputDataBank("bankList", olddata);
          handleInputDataBank("ifsc", "");
          handleInputDataBank("bankname", "");
          handleInputDataBank("bankaccno", "");
          console.log(bankDetails.bankList);
          setBankDetailsErrors({});
        } else {
          setNotifi({ val: true, msg: "Something went wrong" });
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const togglEye = (e, i) => {
    var olddata = bankDetails.bankList;

    let newData = {};
    newData.ifsc = e.ifsc;
    newData.bankname = e.bankname;
    newData.bankaccno = e.bankaccno;
    newData.status = e.status;

    newData.isMasked = !e.isMasked;

    olddata[i] = newData;
    console.log(olddata);
    handleInputDataBank("bankList", olddata);
  };
  const getDepositorData = async () => {
    var url = configData.baseURLBAnkPan;
    var panToken = contextapi.getSession("userData").pan;
    var mobileT = contextapi.getSession("userData").mobile;
    var postData = {
      Pan: profileData.pan === "" ? panToken : profileData.pan,
      Mobile: profileData.mobile === "" ? mobileT : profileData.mobile,
    };
    var options = {
      headers: {
        CLIENT: configData.CLIENT,
        "CLIENT-ID": configData["CLIENT-ID"],
        "CLIENT-SECRET": configData["CLIENT-SECRET"],
      },
    };
    await contextapi
      .postApiwithOpCalling(url, postData, options, false)
      .then((res) => {
        console.log(res);
        if (res.Table1.length > 0) {
          var bankListFromApi = res.Table1;
          var bankList = [];

          bankListFromApi.forEach((element) => {
            if (
              element.ifsccode !== "" &&
              element.BankAcno !== "" &&
              element.BankName !== "" &&
              element.ifsccode &&
              element.BankAcno &&
              element.BankName
            ) {
              let newData = {};
              newData.ifsc = element.ifsccode;
              newData.bankname = element.BankName;
              newData.bankaccno = element.BankAcno;
              newData.status = "verified";
              newData.isMasked = true;
              console.log(newData);

              bankList.push(newData);
            }
          });

          handleInputDataBank("bankList", bankList);
          addBankDetailsFirst(bankList);
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };

  const [editstatus, seteditstatus] = useState({
    status: false,
    data: {},
    index: null,
  });
  const editBankDetails = (that, index) => {
    console.log(that);
    handleInputDataBank("ifsc", that.ifsc);
    handleInputDataBank("bankname", that.bankname);
    handleInputDataBank("bankaccno", that.bankaccno);
    seteditstatus({ status: true, data: that, index: index });
  };
  const [openstatus, setopenstatus] = useState({
    value: false,
    parameters: {},
    index: null,
  });
  const deleteJson = (e, index) => {
    setopenstatus({ value: true, parameters: e, index: index });
    setstep(2);
  };
  const cancelBankEdit = () => {
    handleInputDataBank("ifsc", "");
    handleInputDataBank("bankname", "");
    handleInputDataBank("bankaccno", "");
    seteditstatus({ status: false, data: {}, index: null });
  };
  const saveBankEdit = async () => {
    setGlobalSpinner(true);
    const error = await checkErrors(bankDetails);
    if (Object.keys(error).length > 0) {
      await setBankDetailsErrors(error);
      setGlobalSpinner(false);
    } else {
      var olddata = bankDetails.bankList;
      var url = "/userp/updatemandate";
      var useData = contextapi.getSession("userData").user_key;
      var postData = {
        user_key: useData,
        pan: profileData.pan,
        user_ip: await getClientIp(),
        old_ifsc: editstatus.data.ifsc,
        old_accno: editstatus.data.bankaccno,
        new_ifsc: bankDetails.ifsc,
        new_accno: bankDetails.bankaccno,
        new_bank_name: bankDetails.bankname,
      };
      console.log(postData);
      await contextapi
        .postApiAuthCalling(url, postData, true)
        .then((res) => {
          console.log(res);
          if (res[0].status_code === "00") {
            setNotifi({ val: true, msg: "Bank Updated Successfully" });
            let newData = {};
            newData.ifsc = bankDetails.ifsc;
            newData.bankname = bankDetails.bankname;
            newData.bankaccno = bankDetails.bankaccno;
            newData.status = editstatus.data.status;

            newData.isMasked = editstatus.data.isMasked;

            console.log(newData);
            olddata[editstatus.index] = newData;
            console.log(olddata);
            handleInputDataBank("bankList", olddata);
            handleInputDataBank("ifsc", "");
            handleInputDataBank("bankname", "");
            handleInputDataBank("bankaccno", "");
            setGlobalSpinner(false);
            seteditstatus({ status: false, data: {}, index: null });
          } else {
            setNotifi({ val: true, msg: "Something went wrong" });
            handleInputDataBank("ifsc", "");
            handleInputDataBank("bankname", "");
            handleInputDataBank("bankaccno", "");
            handleInputDataBank("dematList", olddata);
            seteditstatus({ status: false, data: {}, index: null });
          }
        })
        .catch((error) => {
          console.log("Error VerifyUser : ", error);
          // setNotifi({ val: true, msg: "Something went wrong" });
        });
    }
  };
  const finalSubmit = async () => {
    var url = "/userp/profileupdate";
    var useData = contextapi.getSession("userData").user_key;
    var clids = [];
    var user_mandates = [];

    dematData.dematList.forEach((element) => {
      let newData = {};
      newData.dp_name =
        element.depositerName !== "" ? element.depositerName : "null";
      newData.dpid = element.dpid;
      newData.clientid = element.clientid;
      newData.email = element.email;
      newData.mobile = element.mobile;
      newData.src = element.src;
      clids.push(newData);
    });
    bankDetails.bankList.forEach((element) => {
      let newData = {};
      newData.ifsc = element.ifsc;
      newData.bankname = element.bankname;
      newData.bankaccno = element.bankaccno;
      user_mandates.push(newData);
    });
    var postData = {
      user_key: useData,
      pan: profileData.pan,
      name: profileData.name,
      user_ip: await getClientIp(),
      email: profileData.email,
      mobile: profileData.mobile,
      upi_id: profileData.upiList[0],
      upi_id2: profileData.upiList[1],
      upi_id3: profileData.upiList[2],
      upi_id4: profileData.upiList[3],
      upi_id5: profileData.upiList[4],
      clids: clids,
      user_mandates: user_mandates,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setconfirmationName("success");
          setopenstatus({ value: true, parameters: {}, index: null });
          setstep(2);
        } else {
          setNotifi({ val: true, msg: "Something went wrong" });
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  const finalSubmit2 = async () => {
    if (bankDetails.bankList.length > 0) {
      setconfirmationName("success");
      setopenstatus({ value: true, parameters: {}, index: null });
      setstep(2);
    } else {
      setNotifi({
        val: true,
        msg: "Please add atleast one Bank Account to continue .",
      });
    }
  };
  const closestatus = (e) => {
    console.log(e);
    var parameters = openstatus.parameters;
    var index = openstatus.index;
    console.log(parameters);
    if (e === "yes" && confirmationName === "delete") {
      deleteBank(parameters);
    }
    setopenstatus({ value: false, parameters: {}, index: null });
    if (e === "yes" && confirmationName === "success") {
      navigate("/home/dashboard");
    }
    setstep(1);
  };
  const deleteBank = async (parameters) => {
    var url = "/user/deletemandate";
    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      user_key: useData,
      pan: profileData.pan,

      user_ip: await getClientIp(),
      ifsc: parameters.ifsc,
      accno: parameters.bankaccno,
    };
    console.log(postData);
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          let filteredlist = bankDetails.bankList.filter(
            (item) => item !== parameters
          );

          handleInputDataBank("bankList", filteredlist);
          setNotifi({ val: true, msg: "Banks Details deleted Successfully" });
        } else {
          setNotifi({ val: true, msg: "Something went wrong" });
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };
  //APIS
  const ifscValidation = async (value) => {
    if (validator.matches(value, "^[A-Za-z]{4}0[A-Z0-9a-z]{6}$")) {
      setBankDetailsErrors({
        ...bankDetailsErrors,
        ifsc: "",
      });
      var url = configData.baseURLProxy;
      var postData = {
        data: {
          ifsc: value,
          user_ip: await getClientIp(),
        },
        url: configData.baseURLDev + "/user/validateifsc",
      };
      await contextapi
        .postApiAuthCalling(url, postData)
        .then((res) => {
          console.log(res);
          if (res.msg === "sucess") {
            var bank_name = res.data.bank_name;
            handleInputDataBank("bankname", bank_name);
          }
        })
        .catch((error) => {
          console.log("Error VerifyUser : ", error);
        });
    } else {
      setBankDetailsErrors({
        ...bankDetailsErrors,
        ifsc: "Invalid IFSC",
      });
      handleInputDataBank("bankname", "");
    }
  };

  const [step, setstep] = useState(1);
  const renderBank = () => {
    switch (step) {
      case 1:
        return (
          <div className="row">
            <ol className="customol">
            <p className="customol">    You can manually add bank account details if it is not pre-populated and click on Add Account.</p>

            </ol>
            <div className="d-flex align-items-center">
              <div className="col-md-12 row addmargin">
                <div className="col-lg-4 col-md-6 col-ms-12 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="txtIFSC"
                      placeholder="IFSC"
                      name="ifsc"
                      required
                      autoComplete="off"
                      maxLength={11}
                      value={bankDetails.ifsc}
                      onChange={handleBankDetailsChange}
                    />
                    <label htmlFor="txtIFSC">IFSC</label>
                    <Formerror error={bankDetailsErrors.ifsc} />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-ms-12 ">
                  <div className="form-floating emailonhover">
                    <input
                      type="text"
                      className="form-control"
                      id="txtBankName"
                      placeholder="Bank Name"
                      name="bankname"
                      value={bankDetails.bankname}
                      onChange={handleBankDetailsChange}
                      required
                    />
                    <label htmlFor="txtBankName">Bank Name</label>
                    <Formerror error={bankDetailsErrors.bankName} />

                    <div className="inforinemail">

<InfoLogo />
<div className="innerInfo">
  <div className="inner_innerInfo">
    <p>Bank name is retrieved based on the IFSC entered If the specified IFSC is not found in the list, the Bank Name can be entered manually

    </p>
  </div>

</div>

</div>

                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-ms-12 ">
                  <div className="form-floating ">
                    <input
                      type="text"
                      className="form-control"
                      id="txtAccountNumber"
                      placeholder="Account Number"
                      name="bankaccno"
                      value={bankDetails.bankaccno}
                      onChange={handleBankDetailsChange}
                      required
                    />
                    <label htmlFor="txtAccountNumber">Account Number</label>
                    <Formerror error={bankDetailsErrors.bankaccno} />
                  </div>
                </div>
              </div>
              <div className="col-md-1 text-end"></div>
            </div>
            <div className="col-12 text-end ">
            
              {!editstatus.status && (
                <div className="dematBtnHoverdiv marginRight">
                <button
                  type="button"
                  name="button"
                  className="btnInuse btn-secondaryCustom"
                  onClick={handleOnAddAccount}
                >
                  <span className="txt-red"> + </span> Add Account
                </button>

<div className="inforindemat">                      
<div className="inner_innerInfoDematbtn">
  <p>To add details to the below list, click here​

  </p>
</div>   
</div>
</div>

              )}
              
              {editstatus.status && (
                <>
                  <button
                    type="button"
                    name="button"
                    className="btnInuse  btn-secondaryCustom addMargin"
                    onClick={cancelBankEdit}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    name="button"
                    className=" btnInuse btn-default ml-15  makewhitcolor addMargin"
                    onClick={saveBankEdit}
                  >
                    Save
                  </button>
                </>
              )}
            </div>

            {bankDetails.bankList.length > 0 && (
              <div className="col-lg-12 col-sm-12 addextramargin">
                <div className="table-responsive hideformob">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th>Bank Name</th>
                        <th className="w-25">Account Number</th>
                        <th>IFSC</th>
                        {/* <th></th> */}
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {bankDetails.bankList.map((e, i) => (
                        <tr key={i}>
                          <td>{e.bankname}</td>
                          <td className="w-25">
                            {maskingFunction(e.bankaccno, e.isMasked, 4)}
                          </td>
                          <td>{maskingFunction(e.ifsc, e.isMasked, 3)}</td>
                          {/* <td className="alignCenter">
                            {e.status === "verified" ? (
                              <span className="tag-style">
                                Verified
                                <img
                                  src={smallTick}
                                  alt=""
                                  title=""
                                  className="editimg"
                                />
                              </span>
                            ) : (
                              <span className="tag-style red-tag">
                                Non-Verified
                                <img
                                  src={smallTickClose}
                                  alt=""
                                  title=""
                                  className="editimg"
                                />
                              </span>
                            )}
                          </td> */}
                          <td className="alignRight">
                            <img
                              src={view_circle_gray}
                              alt="action"
                              className="actionclass"
                              onClick={() => togglEye(e, i)}
                            />
                            <img
                              src={edit_circle_gray}
                              alt="action"
                              className="actionclass"
                              onClick={() => editBankDetails(e, i)}
                            />
                            <img
                              src={delete_ciircle_gray}
                              alt="action"
                              className="actionclass"
                              onClick={() => deleteJson(e)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mobiletable">
                  {bankDetails.bankList.map((e, i) => (
                    <div className="makeitborder" key={i}>
                      <div className="row">
                        <div className="col-11">
                          <div className="maekflex">
                            <p className="labelTab">Bank Name</p>
                            <p className="valuetab">{e.bankname}</p>
                          </div>
                          <div className="maekflex">
                            <p className="labelTab">IFSC</p>
                            <p className="valuetab">
                              {maskingFunction(e.ifsc, e.isMasked, 4)}
                            </p>
                          </div>
                          <div className="maekflex">
                            <p className="labelTab">Account No</p>
                            <p className="valuetab">
                              {maskingFunction(e.bankaccno, e.isMasked, 3)}
                            </p>
                          </div>
                        </div>
                        <div className="col-1 makitrela">
                          {/* <div>
                            <p>
                              {e.status === "verified" ? (
                                <span className="tag-style">
                                  Verified
                                  <img
                                    src={smallTick}
                                    alt=""
                                    title=""
                                    className="editimg"
                                  />
                                </span>
                              ) : (
                                <span className="tag-style red-tag">
                                  Non-Verified
                                  <img
                                    src={smallTickClose}
                                    alt=""
                                    title=""
                                    className="editimg"
                                  />
                                </span>
                              )}
                            </p>
                          </div>*/}

                          <div className="makeitab">
                            <div className="dropdown">
                              <img
                                src={dotsimg}
                                alt="dotimg"
                                className="dotImage"
                              />
                              <div className="dropdown-content">
                                <p onClick={() => togglEye(e, i)}>{`${
                                  e.isMasked ? "Show" : "Hide"
                                }`}</p>
                                <p onClick={() => editBankDetails(e, i)}>
                                  Edit
                                </p>
                                <p onClick={() => deleteJson(e, i)}>Delete</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="col-lg-12 col-sm-12 textCenter">
              <button
                type="button"
                name="button"
                className="makewhitcolor btnInuse btn-default"
                onClick={() => finalSubmit2()}
              >
                {" "}
                Save{" "}
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="minheigh">
            <UserProfileModal
              openstatus={openstatus.value}
              closestatus={closestatus}
              confirmationName={confirmationName}
              TitleName=""
              dematLinksandName=""
            />
          </div>
        );
    }
  };

  return <>{renderBank()}</>;
};

export default BankDetails;
